import { createSlice, configureStore } from '@reduxjs/toolkit'

const appSlice = createSlice({
    name: 'dDNA-app',
    initialState: {
      auth: null,
      loadingAuth: false,
      members: [],
      isStaffPhysician: false,
      isAdminStaffPhysician: false,
      theme: 'dark',
      headerTheme: null,
      refetchMe: false,
      isRefetchPatient: false,
      openModal: false,
      currentModal: null,
      modalProps: {},
      expandSidebar: true,
      openMobileNav: false,
      showPreLoadingScreen: false,
      selectedFamily: null,
      reports: [],
      patientReports: [],
      isLoadingPatientReports: false,
      medicationFilterOptions: {},
      nutritionFilterOptions: {},
      openChatModal: false,
      showPassedPatientsOnly: false,
      pageScrollTop: {
        patients: 0
      },
      metaData: {
        themeColor: '#12274C'
      },
    },
    reducers: {
      setTheme: (state, action) => {
        state.theme = action.payload;
      },
      setHeaderTheme: (state, action) => {
        state.headerTheme = action.payload
      },
      refetchMe: (state, action) => {
        state.refetchMe = action.payload
      },
      refetchPatient: (state, action) => {
        state.isRefetchPatient = action.payload
      },
      openModal: (state, action) => {
        document.body.style.overflow = 'hidden';
        state.openModal = true;
        state.currentModal = action.payload.currentModal;
        state.modalProps = action.payload.modalProps;
      },
      closeModal: (state, action) => {
        state.openModal = false;
        state.currentModal = null;
        state.modalProps = null;
        document.body.style.overflow = 'auto';
      },
      onModalConfirm: (state, action) => {
        state.params = action.payload.params
      },
      openMobileNav: (state, action) => {
        state.openMobileNav = action.payload;
      },
      setExpandSidebar: (state, action) => {
        state.expandSidebar = action.payload;
      },
      setShowPreLoadingScreen: (state, action) => {
        state.showPreLoadingScreen = action.payload;
      },
      setMetaData: (state, action) => {
        state.metaData = action.payload
      },
      setSelectedFamily: (state, action) => {
        state.selectedFamily = action.payload
      },
      setAuth: (state, action) => {
        state.auth = action.payload
      },
      setMembers: (state, action) => {
        state.members = action.payload
      },
      setLoadingAuth: (state, action) => {
        state.loadingAuth = action.payload
      },
      setIsStaffPhysician: (state, action) => {
        state.isStaffPhysician = action.payload
      },
      setIsAdminStaffPhysician: (state, action) => {
        state.isAdminStaffPhysician = action.payload
      },
      setReports: (state, action) => {
        state.reports = action.payload
      },
      setPatientReports: (state, action) => {
        state.patientReports = action.payload.data
        state.isLoadingPatientReports = action.payload.loading
      },
      setMedicationFilterOptions: (state, action) => {
        state.medicationFilterOptions = action.payload
      },
      setNutritionFilterOptions: (state, action) => {
        state.nutritionFilterOptions = action.payload
      },
      setOpenChatModal: (state, action) => {
        state.openChatModal = action.payload
      },
      setShowPassedPatientsOnly: (state, action) => {
        state.showPassedPatientsOnly = action.payload
      }
    }
  })
  
  export const { 
    setTheme,
    setLocale,
    setHeaderTheme,
    refetchMe,
    refetchPatient,
    openModal,
    closeModal,
    onModalConfirm,
    openMobileNav,
    setExpandSidebar,
    setShowPreLoadingScreen,
    setMetaData,
    setSelectedFamily,
    setAuth,
    setMembers,
    setLoadingAuth,
    setIsStaffPhysician,
    setIsAdminStaffPhysician,
    setReports,
    setPatientReports,
    setMedicationFilterOptions,
    setNutritionFilterOptions,
    setOpenChatModal,
    setShowPassedPatientsOnly
  } = appSlice.actions;
  
  const store = configureStore({
    reducer: appSlice.reducer,
    devTools: true,
  });
  
  export default store;